// extracted by mini-css-extract-plugin
export default {"root":"pbYpn","section":"ws0y4","progress":"uQytZ","success":"A4qpi","note":"ZseUp","brand":"WlCaq"};